// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__35GLh","select":"Header_select__2L124","clinic":"Header_clinic___48wH"};